import { useEffect } from "react";
import useEventEmitter from "@/hooks/use-event-emitter.ts";
import { useAppSelector } from "@/redux/store.ts";

export default function SmartNumber() {
    const eventEmitter = useEventEmitter("smart-number-change");

    const smartNumber = useAppSelector((state) => state.smartNumber.calculatedResult);

    useEffect(() => {
        if (!smartNumber) return;

        eventEmitter(smartNumber);
    }, [eventEmitter, smartNumber]);

    if (!smartNumber) return null;

    return <span>{smartNumber}</span>;
}
